import {algoliaKey} from '../algolia-config';

export const algoliaVzlaEnv = {
  hitsPerPage: '24',
  envs: {
    prod: {
      id: 'VCOJEYD2PO',
      key: algoliaKey.prod,
      index: 'prod-vzla',
      properties: 'properties-vzla',
      propierties : {
        timePromTickets: 'TIME_PROM_TICKETS_VZLA'
      },
      items_seo: 'items_seo_vzla'
    },
    dev: {
      id: 'VCOJEYD2PO',
      key: algoliaKey.dev,
      index: 'dev-vzla',
      properties: 'properties-vzla',
      items_seo: 'items_seo_vzla'
    },
    sandbox: {
      id: 'VCOJEYD2PO',
      key: algoliaKey.sandbox,
      index: 'dev-vzla',
      properties: 'properties-vzla',
      items_seo: 'items_seo_vzla'
    },
  },
  index: ['prod-vzla', 'properties']
};
